import { useMemo } from 'react'
import useQueryGetWithDrawDepositGraph from '@/modules/dashboard/api/hooks/useQueryGetWithDrawDepositGraph'
import DepositWithdrawGraph from '../DepositWithdrawGraph'

interface OverallDepositWithdrawGraphProps {
	startDate?: string
	endDate?: string
}

export default function OverallDepositWithdrawGraph({
	startDate,
	endDate,
}: OverallDepositWithdrawGraphProps) {
	const payload = useMemo(
		() => ({
			startDate: startDate,
			endDate: endDate,
		}),
		[startDate, endDate],
	)
	const { data, isLoading } = useQueryGetWithDrawDepositGraph(payload)

	return (
		<DepositWithdrawGraph
			data={data}
			isLoading={isLoading}
			startDate={payload.startDate}
			endDate={payload.endDate}
			enableSliding={true}
		/>
	)
}
